<template>
  <section class="plugin-faq">
    <h3 class="plugin-faq-title">
      <span class="line"></span>
      <span class="text">插件FAQ</span>
      <span class="line"></span>
    </h3>

    <dl class="qa">
      <dt class="ask">问：为什么插件要选择IOS和安卓？</dt>
      <dd class="answer">答：受限于常用平台的限制，英雄账号下设两个平台的子账号，使用子账号可以玩游戏、访问论坛、登陆开发插件，访问开发者论坛。</dd>
    </dl>

    <dl class="qa">
      <dt class="ask">问：为什么插件的很多操作会要求登陆？</dt>
      <dd class="answer">答：为了账号的安全性，需要登陆才可以使用。</dd>
    </dl>

    <dl class="qa">
      <dt class="ask">问：多个人一起开发怎么办？</dt>
      <dd class="answer">答：多人使用同一账号，维护同一个内容，请保证您分享的账号的安全性。</dd>
    </dl>

    <dl class="qa">
      <dt class="ask">问：创建的地图，想删除怎么办？</dt>
      <dd class="answer">答：暂时不支持删除地图，后续会考虑支持。</dd>
    </dl>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'pluginFaq'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "pluginFaq.styl";
</style>



// WEBPACK FOOTER //
// src/views/pluginFaq/pluginFaq.vue